import { render, staticRenderFns } from "./Topup.vue?vue&type=template&id=4e657dea&scoped=true"
import script from "./Topup.vue?vue&type=script&lang=ts"
export * from "./Topup.vue?vue&type=script&lang=ts"
import style0 from "./Topup.vue?vue&type=style&index=0&id=4e657dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e657dea",
  null
  
)

export default component.exports